<template>
  <div class="modal" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header p-2">
          <h6 class="modal-title">Add Tag(s)</h6>
          <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close" @click="close">
            <span aria-hidden="true"><cancel-icon class="close-icon" style="height: 30px !important;
    width: 30px !important;
    color: #fff;"></cancel-icon></span>
          </button>
        </div>
        <div class="modal-body">
          <!-- <div class="key-style">Name(s)</div> -->
          <!-- <textarea  placeholder="Add multiple tags separated by new line"
          class=" bg-transparent border rounded text-light form-control comm-input-field-in-dialog comm-scroll"
          style="width:400px;height:300px"></textarea> -->
          <input @keyup.enter="addTags()" id="field-focus" ref="fieldSelectionRef" placeholder="Enter tag name" v-model="tagDescription" type="text" class="bg-transparent border rounded text-light form-control input-fields">
          <div class="config-desc mt-1">
                  {{$t('You can add multiple tags with comma(,) seperation')}}.
            </div>
        </div>
        <div class="modal-footer p-0 primary-btn-style">
          <button class="btn btn-outline-secondary mr-3" data-dismiss="modal" @click="close">{{$t('Cancel')}}</button>
          <button class="btn btn-outline-primary mr-2" @click='addTags'>{{$t('Add')}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions} from "vuex"
import cancelIcon from "../core/InlineCancelField.vue"


export default {
  data() {
    return {
      tagDescription:"",
      show:false,
    };
  },
  watch: {
    'show': function (val) {
      if (val) {
          this.$nextTick(() => {
            setTimeout(() => {
                this.$refs.fieldSelectionRef.focus()
            }, 50);
        })
      }
    }
  },
  components:{
        'cancel-icon':cancelIcon
    },
  methods : {
    async addTags() {
      if (this.tagDescription == null || this.tagDescription.trim().length === 0) {
        alert(this.$t("Tag with empty name is not supported.\nPlease enter valid tag name."));
        return false;
      }

      // Split, trim, remove empty values and remove duplicates
      const tagList = [...new Set(
        this.tagDescription
          .split(",")
          .map(tag => tag.trim())
          .filter(tag => tag.length > 0)
      )];

      if (tagList.length === 0) {
        alert(this.$t("Tag with empty name is not supported.\nPlease enter valid tag name."));
        return false;
      }

      for (const tag of tagList) {
        try {
          const payload = {
            name: tag
          };

          const data = await this.addNewTag(payload);

          if (data.statusCode === 200) {
            this.$toast.success(data.message);
          } else {
            this.$toast.error(data.message);
          }
        } catch (error) {
          this.$toast.error(this.$t("Failed to create tag") +  `${tag}`);
        }
      }
      this.close();
    },
    close(){
      this.tagDescription = ""
      this.$emit('close')
    },
    ...mapActions("tags",["addNewTag"])
  },
  mounted(){
    setTimeout(() => {
      this.show = true;
    }, 200)
  },
};
</script>


<style scoped lang="scss">
  $border-color: 1px solid #4a4a4a;
  $border-color-only:#4a4a4a;
  $primary-background: #1a1e21;
  $secondary-background-color:#15181B;
  $bg-color-on-hover: #22272b;
  $text-color: #eee;
  $dull-text-color: #757575;
  $secondary-text-color: #9c9c9c;
  $active-blue : #007bff;
  $input-field-and-label-font-size:14px;
  $danger-color: #dc3545 !important;
  $input-field-height:38px;
  $none-text-color:#4f4f4f;
  $input-field-padding:.375rem 10px;
  $scrollbar-thumb-background:#333;
  $scrollbar-track-background:#1a1e21;
  $scrollbar-thumb-on-hover-background:#555;
  $tags-background-color:#282d31;
  $tags-border-color:#363636;
  $metadata-border-color-on-hover: #5a5a5a;
  $secondary-border-color: 1px solid #2b2b2b;
  $active-green-color:#28a745;
  $svg-color:#666;
  $learn-about-text-color-hover:#b7b327;
  $active-green-icon-color: #00ff3a;
  $learn-about-text-color:#9a9620;
  $icon-hover:#2c3339;

.modal-dialog {
    max-width: 600px;
    width: 600px;
    margin: 0;
    padding: 0;
  }
  
  .modal-content {
    height: auto;
    min-height: 100%;
    border: 0 none;
    border-radius: 0;
    box-shadow: none;
    background: $primary-background !important;
    border: $secondary-border-color;
    .modal-body{
      background: $primary-background;
      padding: 2rem;
    }
  }

.modal {
  text-align: center;
  padding: 0!important;
  display:block;
}
.modal-header .close {
    // margin: -1rem -13px -1rem auto !important;
    margin:0px !important;
    padding: 0px !important;
}
.modal:before {
  content: '';
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  margin-inline-end: -4px;
}
.modal-dialog {
  display: inline-block;
  text-align: start;
  vertical-align: middle;
}

.btn{
    font-size:14px !important;
    height:100%;
}

.border{
    border: $border-color !important;
}

.modal-header,.modal-footer{
    border-top: $secondary-border-color !important;
    border-bottom: $secondary-border-color !important;
    background: $secondary-background-color;
    height: 58px;
    .modal-title{
      color:$text-color;
    }
}

.primary-btn-style{
    margin-top:1%;
    button{
        height: 35px;
        width: 70px;
        font-size:14px;
    }
}

.secondary-btn-style{
  color:$text-color;
}

.key-style {
  color: $dull-text-color;
  width: 30%;
  text-align: start;
  font-size: $input-field-and-label-font-size;
  padding-inline-start: 5px;
  padding-inline-end: 5px;
  margin-top: 3px;
}

.input-fields {
  border: none !important;
  border-bottom: 1px solid $active-blue !important;
  height:30px;
}

.input-fields:focus {
  outline: unset;
  box-shadow:none;
}

.close-icon:hover{
  background: $icon-hover;
  border-radius: 20px;
}
.config-desc{
  color: $dull-text-color;
  font-size:12px;
}

</style>